"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSemanticMetricClientNonAuth = void 0;
/**
 * A builder for SemanticMetricClientNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for SemanticMetricClientNonAuthEvent
 */
function createSemanticMetricClientNonAuth(data) {
    return {
        name: 'SemanticMetricClientNonAuth',
        environments: ['browsernonauth', 'devicenonauth'],
        data: data,
    };
}
exports.createSemanticMetricClientNonAuth = createSemanticMetricClientNonAuth;
//# sourceMappingURL=createSemanticMetricClientNonAuth.js.map